<template>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">User</h2>
        <label class="uk-form-label">Name</label>

        <div class="uk-form-controls">
            {{ name }}
        </div>
        <label class="uk-form-label">Email</label>

        <div class="uk-form-controls">
            {{ email }}
        </div>
        <label class="uk-form-label">Roles</label>
        <div class="uk-form-controls">
            {{ roles }}
        </div>
        <label v-if="entityCount > 1" class="uk-form-label">Entities</label>
        <div v-if="entityCount > 1" class="uk-form-controls uk-margin-medium-bottom">
            {{ entities }}
        </div>
        <div class="uk-margin-medium-bottom"></div>
        <button class="uk-button uk-button-primary uk-modal-close" type="button" :uk-toggle="'target: #' + modalId" @click="editForm">Edit</button>
        <button class="uk-button uk-button-tertiary uk-modal-close" type="button">Cancel</button>
    </div>
</template>

<script>
    export default {

        props: {
            modalId:String,
            formRef:String
        },

        data(){
            return {
                get:"/api/user/get/",
                id:null,
                name:"",
                email: "",
                roles: "",
                entities: "",
                entityCount: 0
            }
        },

        methods:{
            editForm(){
                this.$root.$refs[this.formRef].loadForm(this.id);
            },
            loadForm(id){
                this.id = id;
                axios.get(this.get + id).then((pack) => this.updateFormData(pack));
            },
            updateFormData(pack){
                let data = pack.data.data;
                this.name = data.name;
                this.email = data.email;
                this.roles = data.roleList;
                this.entities = data.entityList;
                this.entityCount = data.entities.length;
            }
        }


    }
</script>
